import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLoupeSearch24 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M10.6256 19.7607C15.6657 19.7607 19.7607 15.6752 19.7607 10.6256C19.7607 5.57597 15.6752 1.5 10.6256 1.5C5.57597 1.5 1.5 5.58551 1.5 10.6256C1.5 15.6657 5.58551 19.7607 10.6351 19.7607H10.6256Z" stroke="currentColor" strokeWidth={1.2} strokeLinecap="square" /><path d="M22.5 22.4993L17.0876 17.0869" stroke="currentColor" strokeWidth={1.2} strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgLoupeSearch24);
export default ForwardRef;